import { BookingEntryWithDifference } from "../../types/BookingEntry";
import React, { useState } from "react";
import { useSnackbar } from "notistack";
import ButtonLoading from "../Button/ButtonLoading";
import LegalbirdIoModal from "../Modal/LegalbirdIoModal";
import ValidatorSelect from "../Validator/ValidatorSelect";
import { MenuItem, SelectChangeEvent } from "@mui/material";
import { apiPatch } from "../../services/Api/apiCall";
import { useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../services/ReactQuery/reactQueryService";

type isPaymentAtRiskModalProps = {
  bookingEntry: BookingEntryWithDifference;
  open: boolean;
  handleClose: () => void;
  updateBookingEntries: Function;
};

export default function HasDefaultRiskModal({
  bookingEntry,
  open,
  handleClose,
  updateBookingEntries,
}: isPaymentAtRiskModalProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [hasDefaultRisk, setHasDefaultRisk] = useState<boolean | null>(bookingEntry.hasDefaultRisk ?? null);

  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  if (!bookingEntry.productType) {
    return null;
  }

  const saveThirdPartyFunds = async () => {
    try {
      setIsLoading(true);
      await apiPatch("/booking_entries", bookingEntry.id, {
        hasDefaultRisk: hasDefaultRisk,
      });
      await queryClient.invalidateQueries({
        queryKey: queryKeys.collections("booking_entries")
      });
      handleClose();
    } catch (e) {
      enqueueSnackbar("Es ist ein Fehler aufgetreten", {
        variant: "error",
        isNonInteractive: true,

        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
      });
    } finally {
      setIsLoading(false);
      updateBookingEntries();
    }
  };

  return (
    <LegalbirdIoModal
      handleClose={() => handleClose()}
      open={open}
      title={"Ausfallgefährdet?"}
      submitButton={
        <ButtonLoading isLoading={isLoading} onClick={saveThirdPartyFunds} variant={"contained"}>
          Speichern
        </ButtonLoading>
      }
    >
      <ValidatorSelect
        label={"Ausfallgefährdet?"}
        value={hasDefaultRisk}
        onChange={(e: SelectChangeEvent) =>
          setHasDefaultRisk(e.target.value === "null" ? null : e.target.value === "true")
        }
      >
        {hasDefaultRisk === null && <MenuItem value={"null"}>-</MenuItem>}
        <MenuItem value={"false"}>Nicht Ausfallgefährdet</MenuItem>
        <MenuItem value={"true"}>Ausfallgefährdet</MenuItem>
      </ValidatorSelect>
    </LegalbirdIoModal>
  );
}
